// Use <@= variable @>, <@- variable @> and <@ expression @> markers
// for _underscore templates so they won't conflict with Twig or Mako.
 /*
  UMD header generated via modularize.js at 2015-04-02T22:08:28.263Z
  unresolved dependencies: idx, i
  assumed dependencies: _gaq
*/
var module; UMD(module, {
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/stacktrace': 'printStackTrace',
  'minted:constants': [],
  'minted:storage_manager': [],
  'minted:vendor/jquery.cookie-1.0': [],
  'minted:url': []
})(this, function (_, m_module, $, printStackTrace) {

var M = m_module.M;

 _.templateSettings = {
    interpolate: /<@=([\s\S]+?)@>/gm,
    evaluate: /<@([\s\S]+?)@>/gm,
    escape: /<@-([\s\S]+?)@>/gm
};

/* string functions */
String.prototype.capitalize = function() {
  var string = this;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

String.prototype.trim = function() {
  return this.replace(/^\s+|\s+$/g,"");
};

String.prototype.substrFromIndex = function(character, length) {
  idx = this.lastIndexOf(character) + 1;
  if (length === undefined) {
    return this.substr(idx);
  } else {
    return this.substr(idx, length);
  }
};

String.prototype.truncate = function(length) {
  var string = this;
  length = length - 3;
  var shortenedString = string.substr(0, length);
  if (shortenedString != string) {
    string = shortenedString.trim() + '...';
  }
  return string;
};

String.prototype.toTitleCase = function () {
  return this.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

/*
 * M.subElement:
 *
 * Create a subelement of parent.  This is a useful macro for building up DOM node hierarchies
 *
 * Arguments
 * parent -- Node, the parent element
 * elementType -- string, the elementType like "DIV"
 * options -- null or an object with following properties:
 *  classes -- an array of strings to be added to the "class" attribute
 *  id -- a string to be set as the element's "id" attribute
 *  src -- a string to be set as the element's "src" attribute
 *
 * Returns:
 * A DOM Node / Element
 *
 * Usage:
 *
 * var someDiv = minted.subElement(document.body, "DIV", {id: "something"});
 *
 */
M.subElement = function(parent, elementType, options) {
  var element = document.createElement(elementType);

  var sel = $(element);
  if (typeof options == "undefined") {
    options = options || {};
  }

  if (options.id) {
    sel.attr("id", options.id);
  }

  if (options.src) {
    sel.attr("src", options.src);
  }

  if (options.html) {
    sel.html(options.html);
  }
  var classes = [];

  if (typeof options.classes == "string") {
    classes = options.classes.split(" ");
  } else if (typeof options.classes == "object") {
    classes = options.classes;
  }
  for (i = 0; i < classes.length; i++) {
      sel.addClass("class", classes[i]);
  }
  if (parent != null) {
    $(parent).append(element);
  }
  return element;
};

/*
 * Create a new object from a prototype.
 *
 * This is a compatibility method for a method which is available in newer
 * browsers such as Google Chrome or Mozilla Firefox.
 *
 * Expected Usage:
 *
 *   var Car = {
 *     init: function() {
 *       this.velocity = 0;
 *     },
 *     stop: function() {
 *       this.velocity = 0;
 *     }
 *   }
 *
 *   var aCar = Object.create(Car).init();
 *
 * See http://javascript.crockford.com/prototypal.html
 */
if (typeof Object.create !== 'function') {
  Object.create = function (o) {
    function F() {}
    F.prototype = o;
    return new F();
  };
}

M.incrementPageCountCookie = function() {
  var pageCounterCookieName = "pageCount",
      pageCount = parseInt($.cookie(pageCounterCookieName), 10);
  if (isNaN(pageCount)) {
    pageCount = 0;
  }
  pageCount++;
  //Make sure that the counter is only incremented once per page view
  M.incrementPageCountCookie = function() {
    return pageCount;
  };

  $.cookie(pageCounterCookieName, pageCount, '/');
  return pageCount;
};

M.isIframe = function() {
  return window.self != window.top;
};

/**
 * Prevent GA from logging pageviews, events caused by Gomez and load
 * testing services.
 */
function emitGATracking() {
  var isGomez = (navigator.userAgent.indexOf('GomezAgent') > -1);
  var isLoadStorm = (navigator.userAgent.indexOf('LoadStorm') > -1);
  var isBrowserMob = (navigator.userAgent.indexOf('Neustar WPM') > -1);
  return !(isGomez || isLoadStorm || isBrowserMob);
}

M.gaTrackViewWrapper = function(target) {
  try {
    if (!emitGATracking()) {
      return;
    }
    _gaq.push(['_trackPageview', target]);
    console.debug('fired ga page view: ' + target);
  } catch(objExc) {
    // noop
  }
};

var gaTrackViewWrapper = M.gaTrackViewWrapper;

// TODO: Move GA functions to separate module and namespace under M.Ga
// e.g. src/js/ga.js.

M.GA = M.GA || {};

// TODO: remove gaTrackEventWrapper() and replace with M.GA.trackEvent()
M.GA.trackEvent = function(target, action, label, value) {
  try {
    if (!emitGATracking()) {
      return;
    }
    if (typeof label == 'undefined') {
      _gaq.push(['_trackEvent', target, action]);
    } else if (typeof value == 'undefined') {
      _gaq.push(['_trackEvent', target, action, label]);
    } else if (typeof value == 'number') {
      _gaq.push(['_trackEvent', target, action, label, value]);
    }
  } catch(objExc) {
    // noop
  }
};

// Add a slight delay before redirecting to make sure
// that the GA event is tracked.
M.GA.trackEventRedirect = function(target, action, label, value, url) {
  M.GA.trackEvent(target, action, label, value);

  var redirectToPage = function() {
    window.location = url;
  };

  _.delay(redirectToPage, M.GA.EVENT_TRACKING_REDIRECT_DELAY);
};

M.GA.trackEventNonInteractive = function(target, action, label, value) {
  try {
    if (!emitGATracking()) {
      return;
    }
    if (typeof(label) == 'undefined') {
      _gaq.push(['_trackEvent', target, action, undefined, undefined, true]);
    } else if (typeof(value) == 'undefined') {
      _gaq.push(['_trackEvent', target, action, label, undefined, true]);
    } else {
      _gaq.push(['_trackEvent', target, action, label, value, true]);
    }
  } catch(objExc) {
    // noop
  }
};

// TODO: remove and update references to M.GA.trackEvent()
var gaTrackEventWrapper = function(target, action, label, value) {
  M.GA.trackEvent(target, action, label, value);
};

/**
 * @param {int} slot The index for the custom variable (1 - 5)
 * @param {string} name The category for the user activity.
 * @param {string} value This value paired with the name.
 * @param {string} scope defaults to page-level. (visitor, session, page)
 */
M.GA.trackCustomVariable = function(slot, name, value, scope) {
  try {
    if (!emitGATracking()) {
      return;
    }
    _gaq.push(['_setCustomVar', slot, name, value, scope]);
  } catch(e) {
    // pass
  }
};

/**
 * Helper function for sending a page_load event to GA and Track API
 * @param eventCategory -- string, of M.GA.TRACK_EVENT_CATEGORY
 * @param pageLoadLabel -- string
 */
M.sendPageLoadEvents = function(eventCategory, pageLoadLabel) {
  var gaData = {};
  var trackData = {};
  gaData['target'] = trackData['feature'] = eventCategory;
  gaData['action'] = trackData['event'] = M.GA.TRACK_EVENT_ACTION.PAGE_LOAD;

  if (typeof(pageLoadLabel) !== 'undefined') {
    gaData['label'] = trackData['label'] = pageLoadLabel;
  }

  M.sendTrackAPIAndGAEvent(gaData, trackData);
};

/**
 * Helper function for sending an event to the track API.
 * @param trackData - object. 'feature' and 'event' are required but other data
 * can be freely passed. https://wiki.minted.com/index.php/Instrumentation
 */
M.sendTrackAPI = function(trackData) {
  M.required(trackData['feature']);
  M.required(trackData['event']);

  $.get("/track", trackData);
};

// TODO: replace with jsUtils.createUrlWithTrackParams from JS-utils
// eg. M.createTrackRedirectUrl = jsUtil.createUrlWithTrackParams;
// because js-utils is written in ES2015, it will require adding it to the
// webpack config as an entry file in order to have it be transpiled properly
M.createTrackRedirectUrl = function(url, trackData) {
  var fragment,
    paramsObject,
    paramsString,
    parts;

  M.required(trackData['feature']);
  M.required(trackData['event']);
  trackData['t_api'] = 1;

  // Get the existing query parameters from the url
  baseUrl = url.split('#')[0];
  fragment = url.split('#')[1];
  parts = baseUrl.split('?');
  paramsObject = M.Url.ParseQuery(parts[1]);

  // Merge existing query parameters with track API parameters
  _.extend(paramsObject, trackData);

  // Serialize the new query params and return the new url
  paramsString = $.param(paramsObject);
  return parts[0] + '?' + paramsString + (fragment ? '#' + fragment : '');
};

/**
 * Helper function for tracking a redirect.
 * Adds track API parameters to a node's href.
 * Should be used with a mousedown event (NOT click) in order to handle
 * middle/cmd-click, and right-click->open in new tab.
 * @param $node - DOM node. Should have an href attribute.
 * @param trackData - object. 'feature' and 'event' are required but other data
 * can be freely passed.
 */
M.appendTrackParameters = function(node, trackData) {
  var $node = $(node);
  var url = $node.attr('href');

  // If target node has an href, append track API parameters and replace it.
  if (url) {
    newUrl = M.createTrackRedirectUrl(url, trackData);
    $node.attr('href', newUrl);
  }
};

/**
 * Helper function for tracking a redirect.
 * Generally you should use appendTrackParameters instead. This should only be
 * used if right/cmd-click is already handled and you are
 * sure this will only be called on left click
 * (i.e. M.View.Browse.ArtMarketplaceQuickLookBar.handleClick)
 * @param url - string. URL that the customer will be sent to
 * @param trackData - object. 'feature' and 'event' are required but other data
 * can be freely passed.
 */
M.trackRedirect = function(url, trackData) {
  var newUrl = M.createTrackRedirectUrl(url, trackData);
  window.location.href = newUrl;
};

/**
 * Helper function for sending an event to both GA and Track API
 * Will redirect with a delay if a url is passed.
 * TODO: Replace this function when we deprecate GA tracking.
 * @param gaData - object, GA data
 * @param trackData - object, track api data
 * @param url - string. Url to redirect the user after the event is tracked.
 */
M.sendTrackAPIAndGAEvent = function(gaData, trackData, url) {
  url = url || undefined;
  try {
    if (gaData) {
      if (url) {
        M.GA.trackEventRedirect(gaData['target'], gaData['action'],
          gaData['label'], gaData['value'], url);
      } else {
        M.GA.trackEvent(gaData['target'], gaData['action'],
          gaData['label'], gaData['value']);
      }
    }
  } catch(e) {
    // pass
  }
  try {
    if (trackData) {
      M.sendTrackAPI(trackData);
    }
  } catch(e) {
    // pass
  }
};

// empty default textarea text on focus, on blur add default text back, onchange remove blur/focus actions
function textboxFocusHelper(domElement, defaultValue) {
  if ($(domElement).length > 0) {
    var textfield = $(domElement);
    var defValue = textfield.val();
    if (typeof(defaultValue) == 'undefined') {
      defValue = defaultValue;
    }
    textfield.focus(function() {
      textfield.val('');
    });
    textfield.change(function() {
      textfield.unbind('focus');
      textfield.unbind('blur');
    });
    textfield.blur(function() {
      textfield.val(defValue);
    });
  }
}

function toggleBlock(control, block) {
  var t = $(control).text();
  var i = t.indexOf(' ');
  var text = $.trim($(control).text().substring(i));
  if ($(control).hasClass('toggleBlockShowing')) {
    $(block).hide();
    $(control).text('show ' + text);
    $(control).removeClass('toggleBlockShowing');
    $(control).addClass('toggleBlockHidden');
  } else {
    $(control).text('hide ' + text);
    $(control).addClass('toggleBlockShowing');
    $(control).removeClass('toggleBlockHidden');
    $(block).show();
  }
}

function copyContent(from, to) {
  $(to).text($(from).val());
}

function plural(count, singular, plural) {
  return (count == 1 ? singular : plural);
}

function stripSpaces(string) {
  return string.replace(/ /g,'');
}

/**
* Returns the value of the isSEMUser cookie which will be true if it is set
*/
function isSEMCookieSet() {
  if (M.COOKIE && $.cookie(M.COOKIE.SEM_USER)) {
    return true;
  } else {
    return false;
  }
}

/**
* Sets a cookie with the name of isSEMUser to true if the current query
* string contains utm_source=google AND utm_medium=ppc.
* Do not set the cookie if utm_term is defined and == 'minted'
* The cookie is set
* with a 30 day expiration.
*/
function setSEMCookie() {
  var queryStringParams = M.Url.parseCurrentQuery();
  if (queryStringParams['utm_source'] == 'google' &&
    queryStringParams['utm_medium'] == 'ppc' &&
    queryStringParams['utm_term'] != 'minted') {
      $.cookie(M.COOKIE.SEM_USER, true, {
        expires: 30,
        path: '/'
      });
  }
}

/**
* Returns the value of the DISPLAY_ADVERTISING_USER cookie which will be true if it is set
*/
function isDisplayAdvertisingCookieSet() {
  if (M.COOKIE && $.cookie(M.COOKIE.DISPLAY_ADVERTISING_USER)) {
    return true;
  } else {
    return false;
  }
}

/**
* Sets a cookie with the name of DISPLAY_ADVERTISING_USER to true if the current query
* string contains utm_medium=onlineadv.
* Do not set the cookie if utm_term is defined and == 'minted'
* The cookie is set with a 30 day expiration.
*/
function setDisplayAdvertisingCookie() {
  var queryStringParams = M.Url.parseCurrentQuery();
  if (queryStringParams['utm_medium'] == 'onlineadv' &&
    queryStringParams['utm_term'] != 'minted') {
      $.cookie(M.COOKIE.DISPLAY_ADVERTISING_USER, true, {
        expires: 30,
        path: '/'
      });
  }
}

// center item to element
(function($) {
  $.fn.center = function(el, offsetX, offsetY) {
    if (typeof el == 'undefined') {
      el = window;
    }
    if (typeof offsetX == 'undefined') {
      offsetX = 0;
    }
    if (typeof offsetY == 'undefined') {
      offsetY = 0;
    }
    return this.each(function() {
      var top = Math.round(($(el).height() / 2) - ($(this).outerHeight() / 2));
      var left = Math.round(($(el).width() / 2) - ($(this).outerWidth() / 2));
      top += offsetY;
      left += offsetX;
      $(this).css({
        position: 'absolute',
        margin: 0,
        top: (top > 0 ? top : 0) + 'px',
        left: (left > 0 ? left : 0) + 'px'
      });
    });
  };
})($);

/**
 * opens a facebook share popup window
 */
function fbs_click(params) {
  var u = location.href + params;
  var t = document.title;
  window.open('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) +
    '&t=' + encodeURIComponent(t), 'sharer',
    'toolbar=0,status=0,width=975,height=565,resizable=1');
  return false;
}

/**
 * opens a facebook feed popup window
 */
function facebook_feed_click(url) {
  window.open(url, 'shareOnFacebook',
    'toolbar=0,status=0,width=600,height=300,resizable=1');
  return false;
}

/**
 * Checks to see if a parameter is present,
 * Note: These two functions are also defined in cu3/utility.js
 * but that module is not stand alone importable.
 *
 * strip is the number of call stack frames to elide in the exception
 * message.  Usually only 0 or 1 is useful here.  This is useful if wrapping
 * M.required.
 */
M.required = function(param, strip) {
  M.assert(param !== undefined,
      'Required Parameter not supplied.',
      (strip || 0) + 1);
};

/**
 * An exception for when the number of arguments passed to a function is wrong.
 *
 * @param {String} message The message for the error.
 * @param {Array} args The arguments that casued the error.
 */
M.IllegalNumberOfArgumentsException = function(message, args) {
  this.name = 'IllegalNumberOfArgumentsException';
  this.message = message || "Wrong number of arguments: " + args;
};
M.IllegalNumberOfArgumentsException.prototype = new Error();
M.IllegalNumberOfArgumentsException.constructor = Error;

/**
 * An exception for when the type of argument is wrong
 *
 * @param {String} message The message for the error.
 * @param {Any} arg The argument that casued the error.
 */
M.IllegalArgumentTypeException = function(message, arg) {
  this.name = 'IllegalArgumentTypeException';
  this.message = message || "Wrong type of arguments: " + arg;
};
M.IllegalNumberOfArgumentsException.prototype = new Error();
M.IllegalNumberOfArgumentsException.constructor = Error;

/*
 * Defining both assert and M.assert lets me delete the three other duplicate
 * definitions of assert.  Ideally all the other calls would be removed
 * at their point of call to use the namespace qualified version.
 *
 * strip is the number of call stack frames to elide in the exception
 * message.  Usually only 0 or 1 is useful here.
 */
M.assert = function(test, optionalMessage, strip) {
  var msg = optionalMessage ? ": " + optionalMessage : '';
  if (!test) {
    M.throwWithStack('Assertion Error' + msg, (strip || 0) + 1);
  }
};

var assert = M.assert;

/*
 * this throws an Error in which the trace is embedded in the error message.
 * Very useful for tracking down errors.
 *
 * strip is the number of call stack frames to elide in the exception
 * message.  Usually only 0 or 1 is useful here.  throwWithStack already
 * eliminates itself from the stack message.
 */
M.throwWithStack = function(msg, strip) {
  var stripDepth = (strip || 0) + 1;
  var err = new Error(msg);
  // This wacky block is to capture the exception succesfully.
  // some browsers don't populate the exception until after it
  // is thrown.
  try {
    throw err;
  } catch(err2) {
    // we slice here to remove this call stack from the message
    var stack = printStackTrace({e: err2}).slice(stripDepth).join('\n');
    // I create a new error because setting the message
    // is apparently not quite the same and this ensures that the
    // 'message' argument in window.onerror contains the stack I want.
    throw new Error(err2.message + ' at ' + stack);
  }
};


M.isValidEmail = function(email) {
  var emailRegex = /[^ ]+@[^ ]+/;
  return emailRegex.test(email);
};

// Loads recent blog posts in the global site footer.
M.displayRecentBlogPosts = function() {
  var $postsContainer = $('#blogPosts');
  if ($postsContainer.length > 0) {
    $.ajax({
      'method': 'GET',
      'url': '/api/blogposts',
      'dataType': 'json',
      success: function(data, status, xhr) {
        for (var i = 0, len = data.length; i < len; i++) {
          var $li = $('<li>');
          var $link = $('<a>');
          $link.attr('href', data[i].url);
          $link.attr('rel', 'bookmark');
          $link.attr('title', data[i].title);
          $link.text(data[i].title);
          $li.append($link);
          $postsContainer.append($li);
        }
      }
    });
  }
};

// Focuses a textbox at the end of the text. Stolen from
// http://stackoverflow.com/questions/4609405/
// set-focus-after-last-character-in-text-box
M.setCaretAtEnd = function(elem) {
  var elemLen = elem.value.length;
  var isIE = document.selection;
  // Does not work for IE
  if (!isIE) {
    if (elem.selectionStart || elem.selectionStart == '0') {
      // Firefox/Chrome
      elem.selectionStart = elemLen;
      elem.selectionEnd = elemLen;
    }
  }
  elem.focus();
};

// Create tracking pixel
// DO NOT use this to create script pixel, use AddScriptTag instead
// eg. url = https://secure.adnxs.com/seg?add=830875&t=2
//     pixelType = <iframe>
//     attrArray = {"scrolling" : "0", "frameborder":"0"}
M.CreateTrackingPixel = function(url, pixelType, attrArray) {

  var $pixel;
  if (pixelType) {
    $pixel = $(pixelType);
  } else {
    $pixel = $('<img>');
  }

  $pixel.attr('src', url);
  for (var param in attrArray) {
    $pixel.attr(param, attrArray[param]);
  }
  $pixel.hide();
  $('body').append($pixel);
};

// Create a script tag
M.AddScriptTag = function(src, attrArray) {

  var newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  if (src) {
    newScript.src = src;
  }
  newScript.async = true;

  for (var param in attrArray) {
    newScript[param] = attrArray[param];
  }

  var script = document.getElementsByTagName('script')[0];
  script.parentNode.insertBefore(newScript, script);
};


M.sprite_placeholder = function() {
  return M.img_src('/static/images/sprite_placeholder.png');
};

// Return a greeting url param from an alt greeting name;
// ie. NEW_YEAR => NEWYEAR
M.GetGreetingUrlParamFromName = function(greetingName) {
  if (!greetingName) return;
  return greetingName.toUpperCase().
    trim().
    replace(' ', '').
    replace('_', '');
};

M.addTrackingPixel = function() {
  var landingPageName = M.landingPageName || 'other';
  var productSku = M.productSku;
  var productPrice = M.productPrice;

  // Add google conversion pixel on all pdp pages
  if (productSku && productPrice) {
    window.google_tag_params = {
      ecomm_prodid: productSku,
      ecomm_pagetype: landingPageName,
      ecomm_totalvalue: productPrice
    };
  }
  else {
    window.google_tag_params = {
      ecomm_pagetype: landingPageName
    };
  }

};

M.setHtmlById = function(id, str) {
  document.getElementById(id).innerHTML = str;
}

M.PBT = {
  hostnameForURL: function(url) {
    // Simple Javascript URL parsing - https://gist.github.com/jlong/2428561
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  },

  // dequoteCookieValue(), decodeCookieString() and readCookie() adapted from https://github.com/carhartl/jquery-cookie to remove jQuery loading dependency
  readCookie: function(key) {
    var value = null;
    if (window.document.cookie && window.document.cookie != "") {
        var cookies = window.document.cookie.split("; ");
        for (var i = 0; i < cookies.length; i++) {
            var part = cookies[i]
            if (part.substring(0, key.length + 1) == key + "=") {
                value = decodeURIComponent(part.substring(key.length + 1));
                break
            }
        }
    }
    return value
  },

  setCookie: function(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";

    var cookieDomain = window.location.hostname === 'www.minted.com' ? '.minted.com' : '.' + window.location.hostname;
    document.cookie = name + "=" + value + expires + "; path=/; domain=" + cookieDomain + ";";
  },

  parameterHashForURL: function(url) {
    var search;
    if (url) {
      var a      = document.createElement('a');
          a.href = url;
      search = a.search;
    } else {
      search = window.location.search
    }
    search = search.substr(1); // Remove '?' at beginning of string
    var params = {};
    var parts = search.split('&');
    for(var i = 0; i < parts.length; i++ ) {
      var param = parts[i];
      var keyLength = param.indexOf('=');
      if (keyLength !== -1) {
        var key   = param.substring(0, keyLength),
            value = param.substring(keyLength + 1),
            value = value.replace(/\+/g, " ");
        params[key] = value;
      }
    }
    return params;
  }
};

/**
 * Checks to see whether a user matches certain marketing tracking parameters.
 *
 * @param {Object} opts. Tracking options to match.
 *
 * @return {Boolean} Whether or not the user matches the passed in trackign options.
 */
M.matchVisitor = function(opts) {

  // opts[source]        => "facebook.com"
  // opts[medium]        => ""
  // opts[campaign]      => ""
  // TBD - opts[country] => ['US', 'CA', 'UK']

  // These are explicitly set URL parameters.
  // The one exception is glcid which is set automatically by Google AdWords
  var UTM_SOURCE   = 'utm_source',
      UTM_CAMPAIGN = 'utm_campaign',
      UTM_MEDIUM   = 'utm_medium',
      UTM_TERM     = 'utm_term',
      UTM_CONTENT  = 'utm_content',
      UTM_AD_CLICK = 'gclid';

  var utm = {};
  utm.source   = null;
  utm.campaign = null;
  utm.medium   = null;
  utm.term     = null;
  utm.content  = null;
  utm.ad_click = null;

  var params     = M.PBT.parameterHashForURL(),
      mtmzCookie = M.PBT.readCookie('__mtmz'), // "minted tracking module"
      firstTouch = M.PBT.readCookie('pbt_first_touch');

  // We want to consider anyone who first touches minted on the homepage as brand user and therefore exempt from channel promos
  if (mtmzCookie === null && firstTouch === null) {
    // User is new
    var firstPath = window.location.pathname;
    M.PBT.setCookie('pbt_first_touch', firstPath, 60);
    firstTouch = firstPath;
  }

  if (firstTouch === "/") {
    // Exclude users who's first touch is homepage, regardless of source.
    return false;
  }

  // UTM Tag Priority:
  // 1. utm URL parameters (utm_source, etc)
  // 2. ad click URL parameter (gclid)
  // 3. __mtmz cookie values
  // 4. HTTP Referrer
  if (params[UTM_SOURCE] || params[UTM_CAMPAIGN] || params[UTM_MEDIUM] || params[UTM_CONTENT]) {
    // utm URL parameters detected
    utm.source   = params[UTM_SOURCE]   || "()";
    utm.campaign = params[UTM_CAMPAIGN] || "()";
    utm.medium   = params[UTM_MEDIUM]   || "()";
    utm.term     = params[UTM_TERM]     || "()";
    utm.content  = params[UTM_CONTENT]  || "()";
    utm.ad_click = null;
  } else if (params[UTM_AD_CLICK]) {
    // ad click URL parameter detected
    // In testing, I've found the existance of this parameter to be mutually exclusive with utm URL parameters
    utm.source   = "google";
    utm.medium = "cpc";
    // Google looks these values up using the ad click id, we don't have access to them since they're "private" adwords campaign names
    utm.campaign   = null;
    utm.term     = null;
    utm.content  = null;
    utm.ad_click = params[UTM_AD_CLICK];
  } else if (mtmzCookie) {
    // __mtmz cookie detected
    cookieData = JSON.parse(mtmzCookie);

    utm.source   = cookieData[UTM_SOURCE]
    utm.campaign = cookieData[UTM_CAMPAIGN];
    utm.medium   = cookieData[UTM_MEDIUM];
    utm.term     = cookieData[UTM_TERM];
    utm.content  = cookieData[UTM_CONTENT];
    utm.ad_click = cookieData[UTM_AD_CLICK];
  } else if (document.referrer.length > 0) {
    // Fallback to URL parameters and HTTP Referrer
    utm.source   = M.PBT.hostnameForURL(document.referrer);
    utm.campaign = "()";
    utm.medium   = "referral";
    utm.term     = "()";
    utm.content  = "()";
    utm.ad_click = null;
  }

  if (
    !mtmzCookie ||
    params[UTM_SOURCE] ||
    params[UTM_CAMPAIGN] ||
    params[UTM_MEDIUM] ||
    params[UTM_CONTENT] ||
    params[UTM_AD_CLICK]
  ) {
    var mtm = {};
    mtm[UTM_SOURCE] = utm.source;
    mtm[UTM_CAMPAIGN] = utm.campaign;
    mtm[UTM_MEDIUM] = utm.medium;
    mtm[UTM_TERM] = utm.term;
    mtm[UTM_CONTENT] = utm.content;
    mtm[UTM_AD_CLICK] = utm.ad_click;
    M.PBT.setCookie('__mtmz', JSON.stringify(mtm), 60);
  }

  // Iterate through each UTM tag to see if it matches
  var visitorMatches = true;
  var checks = ["source", "medium", "campaign", "term", "content"];
  for (var i=0; i<checks.length; i++) {
    var utmType = checks[i];
    var expectedUtmValue = opts[utmType];
    var actualUtmValue   = utm[utmType] || "";

    // If we have both specified to check a UTM tag and we have detected a value for that tag
    if(expectedUtmValue) {
      expectedUtmValue = expectedUtmValue.toLowerCase();
      actualUtmValue = actualUtmValue.toLowerCase();
      visitorMatches = visitorMatches && actualUtmValue === expectedUtmValue;
    }
  }

  return visitorMatches;
};

M.getUserFacts = function(callback) {
  if (localStorage.userFacts) {
    var userFacts = JSON.parse(atob(localStorage.userFacts));
    if (userFacts.expiration >= new Date().getTime()) {
      callback(userFacts.data);
      return;
    }
  }

  $.ajax({
    url: '/users/personalization/facts',
    global: false,
    success: function(data) {
      var userFacts = {};
      userFacts.expiration = new Date().getTime() + (60 * 1000);  // 1min
      userFacts.data = JSON.parse(atob(data));
      localStorage.userFacts = btoa(JSON.stringify(userFacts));
      callback(userFacts.data);
    },
    error: function() {
      callback({});
    }
  });
};

/**
 * Gets user segments from '_su' cookie, from localStorage,
 * or from Bijou (in this order).
 *
 * @param {function} callback. Called on an array of user segment titles,
 * e.g. ['0XHOL', 'WED', 'BESTCUSTOMEREVER']
 */
M.getUserSegments = function(callback) {
  var USER_SEGMENT_DELIMITER = '|';

  function convertSegmentListToTitlesOnly(list) {
    return list.map(function(segment) {
      if (typeof segment === 'object') {
        return segment.title;
      }
      return segment;
    });
  }

  // Checks cookie so cookie value can be used for testing user segmentation
  // Currently cookie is set by /get-user-personalization-info endpoint
  // for 1 hour, in the future, user segmentation should be updated in real time (TODO)
  var segmentsFromCookie = M.PBT.readCookie('_su');
  if (segmentsFromCookie) {
    // user segments are stored as a string in cookie
    // e.g. '0XHOL WED BESTCUSTOMEREVER', delimited by space
    segmentTitlesList = segmentsFromCookie.split(USER_SEGMENT_DELIMITER);
    return callback(segmentTitlesList);

  } else if (localStorage.userSegments) {
    var segmentsFromLocalStorage = JSON.parse(atob(localStorage.userSegments));
    if (segmentsFromLocalStorage.expiration >= new Date().getTime()) {
      segmentTitlesList = convertSegmentListToTitlesOnly(segmentsFromLocalStorage.data);
      return callback(segmentTitlesList);
    }
  }

  $.ajax({
    url: '/users/personalization/segments',
    global: false,
    success: function(data) {
      var segments = {};
      segments.expiration = new Date().getTime() + (60 * 1000);  // 1min
      segments.data = JSON.parse(atob(data));
      localStorage.userSegments = btoa(JSON.stringify(segments));
      segmentTitlesList = convertSegmentListToTitlesOnly(segments.data);

      callback(segmentTitlesList);
    },
    error: function() {
      callback([]);
    }
  });
};

M.validateSegments = function(validateOp, segmentsToValidate, userSegments) {
  segmentsToValidate = segmentsToValidate || [];

  validateOp = (['anyOf', 'allOf', 'oneOf', 'not'].indexOf(validateOp) > -1) ? validateOp : 'anyOf';
  function isInSegment(segment) {
    return userSegments.indexOf(segment) > -1;
  }

  switch (validateOp) {
    case 'anyOf':
      return segmentsToValidate.some(isInSegment);
    case 'allOf':
      return segmentsToValidate.every(isInSegment);
    case 'oneOf':
      var validatedSegments = segmentsToValidate.filter(isInSegment);
      return (validatedSegments.length === 1);
    case 'not':
      return !segmentsToValidate.some(isInSegment);
    default:
      return false;
  };
};

M.makeSticky = function(key) {
  // this makes the key sticky in local storage
  var stickyContent = {};
  if (localStorage.stickyContent) {
    stickyContent = JSON.parse(localStorage.stickyContent);
  }
  if (!stickyContent[key]) {
    M.sendTrackAPI({feature: 'make_sticky', event: key});
    stickyContent[key] = true;
    localStorage.stickyContent = JSON.stringify(stickyContent);
  }
};

M.isSticky = function(key) {
  // this checks to see if they key has been set to sticky
  if (!localStorage.stickyContent) {
    return false;
  }
  return JSON.parse(localStorage.stickyContent)[key];
};

M.fakeUserFacts = function(newFacts) {
  var userFacts = {};
  if (localStorage.userFacts) {
    userFacts = JSON.parse(atob(localStorage.userFacts));
  }
  var mergedFacts = _.assign({}, userFacts, {data: newFacts});
  mergedFacts.expiration = new Date().getTime() + (3 * 60 * 1000);  // 3min
  localStorage.userFacts = btoa(JSON.stringify(mergedFacts));
};

M.fakeUserSegments = function(newSegments) {
  var userSegments = {};
  if (localStorage.userSegments) {
    userSegments = JSON.parse(atob(localStorage.userSegments));
  }
  var mergedSegments = _.assign({}, userSegments, {data: newSegments});
  mergedSegments.expiration = new Date().getTime() + (3 * 60 * 1000);  // 3min
  localStorage.userSegments = btoa(JSON.stringify(mergedSegments));
};

(function() {
  // a scope for concerns related to parsing text/drupal template scripts

  function getStickyContext(callback) {
    // a deferred that resolves to provide the 'sticky' context variables
    var deferred = $.Deferred();
    deferred.resolve({
      stick: M.makeSticky,
      sticky: M.isSticky
    });
    return deferred;
  }

  function getUserFactsContext(callback) {
    // a deferred that resolves to provide the 'user_facts' context variables
    var deferred = $.Deferred();
    M.getUserFacts(function(facts) {
      deferred.resolve({
        user_fact: function(path) {
          // explode dot notation from the path and resolve it in the facts object
          return path.split('.').reduce(function(obj, name) {
            return (obj && obj[name]) ? obj[name] : null;
          }, facts);
        }
      });
    });
    return deferred;
  }

  function getUserSegmentsContext(callback) {
    // a deferred that resolves to provide the 'user_segments' context variables
    var deferred = $.Deferred();
    M.getUserSegments(function(userSegments) {
      deferred.resolve({
        validate_segments: function() {
          var validateOp, segmentsToValidate;
          if (typeof arguments[0] === 'string') {
            validateOp = arguments[0];
            segmentsToValidate = arguments[1];
          } else {
            validateOp = 'anyOf';
            segmentsToValidate = arguments[0];
          }
          return M.validateSegments(validateOp, segmentsToValidate, userSegments);
        }
      });
    });
    return deferred;
  }

  function getContextObject(name) {
    // routing for each data-context item, resolves to an object with variables to add
    // to the template context when rendering
    switch (name) {
      case 'sticky':
        return getStickyContext();
        break;
      case 'user_facts':
        return getUserFactsContext();
        break;
      case 'user_segments':
        return getUserSegmentsContext();
        break;
      default:
        return $.Deferred().resolve({});
        break;
    }
  }

  function renderTemplate(contexts, templateString, callback) {
    var contextDeferreds = contexts.map(getContextObject);
    $.when.apply(this, contextDeferreds).then(function() {  // wait for all context objects
      var context = {};
      // add variables from each context object to the template's context
      for (var i in arguments) {
        _.extend(context, arguments[i]);
      }
      var originalTemplateSettings = _.templateSettings;
      _.templateSettings = {  // switch back to default underscore template syntax
        interpolate: /\<\%\=(.+?)\%\>/gim,
        evaluate: /\<\%(.+?)\%\>/gim
      };
      try {
        var render = _.template(templateString);
        var html = $.trim(render(context));
        callback(html);
      } catch (e) {  // don't let drupal template rendering break the page
        console.log('%cOh no!%c Drupal template couldn\'t render: %s', 'background-color: #cc0000; color: #ffffff', 'background-color: #ffffff; color: #000000',  e);
        console.log('%cHere is the template that failed:%c%s', 'color: #222222;', 'display: block; font-family: monospace; white-space: pre; color: #444444;', templateString);
      }
      _.templateSettings = originalTemplateSettings;  // apply minted-style templates again
    });
  }

  $(document).ready(function() {
    $('script[type="text/drupal"]').each(function() {  // search for drupal template scripts
      var $script = $(this);
      var contextString = $script.data('context') || '';
      var contexts = contextString.split(',').map($.trim);
      var templateString = $script.html();
      renderTemplate(contexts, templateString, function(html) {
        // stick DOM from the renderered drupal template directly into the DOM where the
        // original script tag appears
        $(html).insertAfter($script);
      });
    });
  });
})();

$(document).ready(function() {
  // this block of code is amazingly awesome.
  // in some cases document.ready is synchronous.
  // like say when requirejs is running and it's initalizing
  // this block of code after document.ready has happened.
  // if that's the case, and we're still in the factory, we
  // haven't set the globals necessary to make
  $("a[resetsearch]").bind('click', function() {
    // Reset the search before going to the specific url
    var targetUrl = $(this).attr('href');
    $('body').data('searchJumpUrl', targetUrl);
    $.get('/search?resetFilters=1&noredir=1', {
      targetUrl: targetUrl
    },
    function(data) {
      var targetUrl = $('body').data('searchJumpUrl');
      document.location = targetUrl;
      return (false);
    });
    return (false); // never let regular link take charge
  });

  if (!isSEMCookieSet()) {
    setSEMCookie();
  }
  if (!isDisplayAdvertisingCookieSet()) {
    setDisplayAdvertisingCookie();
  }
  M.addTrackingPixel();
  M.incrementPageCountCookie();
  if ( ! window.isSEMCookieSet ) {
    /*
     * this code should seriously never be
     * this deferred initialization should
     * really be wrapping in a header
     * that really actually guarentees
     * that all the dependencies are fully loaded
     * properly
     *
     */
    window.isSEMCookieSet = isSEMCookieSet;
    window.isDisplayAdvertisingCookieSet = isDisplayAdvertisingCookieSet;
  }
  var emailDialog = new M.View.EmailDialog();
  emailDialog.renderIfNotLoggedIn();
});

function saveddesign() {
  gaTrackEventWrapper("saved designs", "view saved designs");
}

function selectAllText(textbox) {
  $(textbox).focus();
  $(textbox).select();
}

/**
 * Bind an event to the browser's onbeforeunload, which happens when a
 * user tries to navigate away from the page. Will display a dialog with
 * the specified string if the checkFunction returns true.
 *
 * @param {String} eventMessage The message to display to the user in the
 * native JS alert box.
 * @param {Function} checkFunction A function to run to check whether the
 * alert box should be displayed or not. Function should return Boolean.
 */
M.bindCloseEvent = function(eventMessage, checkFunction) {
  window.onbeforeunload = function() {
    if (checkFunction()) {
      return eventMessage;
    } else {
      return null;
    }
  };
};

/**
 * Unbinds the window's onbeforeunload so no alert comes up.
 */
M.unbindCloseEvent = function() {
  window.onbeforeunload = null;
};

(function () {
  var dialogs = [];

  var addDialog = function (el) {
    dialogs.push(el);
    var index = dialogs.length - 1;
    el.bind('dialogclose dialogdestroy', function () {
      dialogs.splice(index, 1);
    });
  };

  M.closeDialogOnMaskClick = function (el) {
    var $el = $(el);
    $el.bind('dialogopen', _.bind(addDialog, null, $el));
  };

  var overlaySelector = '.ui-widget-overlay';

  var closeHandler = function () {
    _.each(dialogs, function (el) {
      el.dialog('close');
    });
  };

  var designerProfileLinkSelector = 'a[href^="/search?"][href*="designerID="]';
  var designerStorefrontLinkSelector = 'a[href^="/store/"],' +
        'a[href^="/storefront/"]';

  var designerProfileLinkHandler = function(e) {
    if (!$(e.target).hasClass('noPopover')) {
      e.preventDefault();
      e.stopPropagation();
      var $target = $(e.target);
      if (!$target.is('a')) {
        $target = $target.parents('a');
      }
      M.View.DesignerStorefront.Popover.setLocationAndRender(
          $target.attr('href'));
    }
  };

  // TODO: do not execute community-specific code in the base.js file like this
  // These community-specific event handlers break other parts of the site like
  // checkout on mobile. Refactor this code out into a community module.
  var isCheckoutUrl = (/(checkout|revieworder)/.test(window.location.href));

  // TODO: Do not globally attach click handlers to the body like this.
  $(document).ready(_.once(function () {
    var $body = $(document.body);
    // Find an appropriate method to lazily bind to the click event of
    // overlays as they are created.
    if ($body.on) {
      $body.on('click', overlaySelector, closeHandler);
      if (!isCheckoutUrl) {
        $body.on('click', designerProfileLinkSelector, designerProfileLinkHandler);
        $body.on('click', designerStorefrontLinkSelector, designerProfileLinkHandler);
      }
    } else if ($body.delegate) {
      $body.delegate(overlaySelector, 'click', closeHandler);
      if (!isCheckoutUrl) {
        $body.delegate(designerProfileLinkSelector, 'click', designerProfileLinkHandler);
        $body.delegate(designerStorefrontLinkSelector, 'click', designerProfileLinkHandler);
      }
    } else if ($body.live) {
      $(overlaySelector).live('click', closeHandler);
      if (!isCheckoutUrl) {
        $(designerProfileLinkSelector).live('click', designerProfileLinkHandler);
        $(designerStorefrontLinkSelector).live('click', designerProfileLinkHandler);
      }
    }
  }));
})();

/**
 * Get or set a local storage value that determines whether or not the
 * filters should be "introduced" with an animation when the user loads
 * the page. When called with no arguments, it returns a boolean that
 * represents whether the filters should be introduced. When called with
 * an argument, the value passed in will be the new value for this local
 * storage key.
 *
 * If local storage contains the session id, this function returns false.
 * Otherwise, it returns true.
 *
 * @param {Boolean} onOrOff Optional. When onOrOff is true, the session
 * id is stored in localStorage. Otherwise the key is deleted. The affect
 * is to turn on future introductions when true and to turn off future
 * introductions when false.
 *
 * @return {Boolean} Whether or not filters should be introduced.
 */
M.shouldIntroduceFilters = function (onOrOff) {
  var key = M.LOCAL_STORAGE_KEYS.CATEGORY.INTRODUCE_FILTERS,
      val;
  if (arguments.length === 0) {
    val = M.localStorageManager.get(key);
    if (val == null) {
      // When a session id cookie has been recently cleared, there may not
      // be a new one yet. This allows us the store the new session id as
      // soon as we have it.
      console.warn(
        'Resetting localStorage["' + key + '"] to current session id.');
      return M.shouldIntroduceFilters(false);
    }
    return val;
  } else if (onOrOff) {
    M.localStorageManager.remove(key);
  } else {
    M.localStorageManager.set(key, false);
  }
  return onOrOff;
};

/**
 * Allows us to lazily compile templates, saving on initial page load time.
 *
 * @param {String} templateString The string to compile
 *
 * @return {Function} A template function that works exactly the same as the
 * result of _.template, except it calls _.template(templateString) on the
 * first invocation and caches the result to be used on subsequent calls.
 */
M.template = function(templateString) {
  var compiledTemplate = null;
  return function() {
    if (compiledTemplate == null) {
      compiledTemplate = _.template(templateString);
    }
    return compiledTemplate.apply(this, arguments);
  };
};

if ( window.M &&
  typeof window.M.renderEmailGate !== 'undefined' &&
  typeof window.M.DEVICE_TYPE !== 'undefined' ) {
  //prevents load order problem
  window.M.renderEmailGate();
}

return {
  'emitGATracking': emitGATracking,
  'gaTrackViewWrapper': gaTrackViewWrapper,
  'gaTrackEventWrapper': gaTrackEventWrapper,
  'textboxFocusHelper': textboxFocusHelper,
  'toggleBlock': toggleBlock,
  'copyContent': copyContent,
  'plural': plural,
  'stripSpaces': stripSpaces,
  'isSEMCookieSet': isSEMCookieSet,
  'setSEMCookie': setSEMCookie,
  'isDisplayAdvertisingCookieSet': isDisplayAdvertisingCookieSet,
  'setDisplayAdvertisingCookie': setDisplayAdvertisingCookie,
  'fbs_click': fbs_click,
  'facebook_feed_click': facebook_feed_click,
  'assert': assert,
  'saveddesign': saveddesign,
  'selectAllText': selectAllText
};

});
